import { DetailedHTMLProps, FormHTMLAttributes } from 'react';

import { Form } from 'src/components';

import styles from './TableFilters.module.scss';


type TProps = DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

export function TableFilters(props: TProps) {
	const {
		children,
		className = '',
		...restProps
	} = props;

	const classNames = [styles.filters];

	if (className) {
		classNames.push(className);
	}

	return (
		<Form className={ classNames.join(' ') } { ...restProps }>
			{ children }
		</Form>
	);
}
